// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__Tsd35","subtitle":"Card_subtitle__IhOBv"};